module.exports = __webpack_public_path__ + "img/grace_greige_ba_list.38398c94.jpg";